import { configureStore } from '@reduxjs/toolkit'
import gameReducer, { initGame } from './slices/gameSlice'
import settingsReducer, { initSettings } from './slices/settingsSlice';

export const store = configureStore({
    reducer: {
        game: gameReducer,
        settings: settingsReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})

export const initialize = ({ settings, customizations, ...config }) => {
    store.dispatch(initGame(config))
    store.dispatch(initSettings({ settings, customizations }))
}